import React from 'react';
import Items from './Items';
import ProductSearchProvider from '~view/widgets/ProductSearchProvider';

const NewProducts: React.FC<{ category?: string }> = ({ category }) => {
  const listId = `products > new${category ? ` > ${category}` : ''}`;
  return (
    <ProductSearchProvider
      listId={listId}
      category={category}
      filterValues={{
        publishedAtTimestamp: [
          `publishedAtTimestamp >= ${
            new Date().getTime() - 30 * 24 * 60 * 60 * 1000
          }`,
        ],
      }}
      itemsPerPage={50}
      groupByBrand
      personalize
    >
      <Items listId={listId} />
    </ProductSearchProvider>
  );
};

export default NewProducts;
